import template from './dashboard-card-activity.component.html';
import controller from './dashboard-card-activity.controller';

const dashboardCardActivity = {
  template,
  controller,
};

export default dashboardCardActivity;
